import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from '@fitness-force/api';
import { AutomationScheduleType, AutomationTimings } from '@fitness-force/enum';
import { AutomationMaster } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'automation-schedule-type',
  templateUrl: './automation-schedule-type.component.html',
  styleUrls: ['./automation-schedule-type.component.css'],
  providers:[ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    ButtonModule,
    TranslateModule,
    MessageModule
  ]
})

export class AutomationScheduleTypeComponent implements OnInit {
  @Input('automationMaster') automationMaster = new BehaviorSubject<AutomationMaster>({} as AutomationMaster);
  @Input() formGroup: UntypedFormGroup = new UntypedFormGroup({});
  @Input() controlName: UntypedFormControl = new UntypedFormControl();
  @Input() scheduleInMin: number = 0;
  @Input() type: string = 'EMAIL';

  automationTimingOptions: any;
  automationScheduleTypes: { key: string; value: string; }[] = [];

  sendMessageOptions:any=[];
  selectedSendMessageOption: string | null = null;
  showDefaultMessage:boolean=false;

  constructor(private commonService: CommonService, private translateService : TranslateService, public cd: ChangeDetectorRef) {
    this.sendMessageOptions = ['After','Before','OnEvent'];
   }

  ngOnInit() {
    if (this.automationMaster.value) {  
      if (this.automationMaster.value.automation_schedule_type && (this.automationMaster.value.automation_schedule_type == AutomationScheduleType.Day
        || this.automationMaster.value.automation_schedule_type.toString() == AutomationScheduleType[AutomationScheduleType.Day])) {
        this.automationScheduleTypes.push({
          key: AutomationScheduleType[AutomationScheduleType.Day],
          value: AutomationScheduleType[AutomationScheduleType.Day],
        });
      }
      else if (this.automationMaster.value.automation_schedule_type && (this.automationMaster.value.automation_schedule_type == AutomationScheduleType.Hour
        || this.automationMaster.value.automation_schedule_type.toString() == AutomationScheduleType[AutomationScheduleType.Hour])) {
        this.automationScheduleTypes.push({
          key: AutomationScheduleType[AutomationScheduleType.Day],
          value: AutomationScheduleType[AutomationScheduleType.Day],
        },
          {
            key: AutomationScheduleType[AutomationScheduleType.Hour],
            value: AutomationScheduleType[AutomationScheduleType.Hour]
          });
      }
      else {
        this.automationScheduleTypes.push({
          key: AutomationScheduleType[AutomationScheduleType.Day],
          value: AutomationScheduleType[AutomationScheduleType.Day]
        },
          {
            key: AutomationScheduleType[AutomationScheduleType.Hour],
            value: AutomationScheduleType[AutomationScheduleType.Hour]
          },
          {
            key: AutomationScheduleType[AutomationScheduleType.Minute],
            value: AutomationScheduleType[AutomationScheduleType.Minute]
          })
      }
      if (this.SelectedAutomationTimingFormControl.value == "" && this.SelectedAutomationScheduleTypeFormControl.value == "") {
        if(this.isBackendAutomation()){
          this.SelectedAutomationScheduleTypeFormControl.clearValidators();
          this.SelectedAutomationTimingTypeFormControl.clearValidators();
          this.SelectedAutomationTimingTypeFormControl.setValue("System Default");
          this.selectedSendMessageOption = "System Default";
          this.SelectedAutomationTimingFormControl.clearValidators();
          this.showDefaultMessage = true;
        }
        else{
          var timing = this.automationMaster.value.automation_timings.find(timing => timing != AutomationTimings[AutomationTimings.NonAutomation]);
          this.SelectedAutomationTimingTypeFormControl.setValue(timing);
          if(timing == "Immediate" || timing == "SameDay"){
            this.selectedSendMessageOption = "OnEvent";
          }
          else{
            this.selectedSendMessageOption = timing!;
          }
          this.SelectedAutomationTimingTypeFormControl.setValidators(Validators.required);
          this.showDefaultMessage = false;
        }

        if (this.automationMaster.value.automation_schedule_type == AutomationScheduleType.Day
          || this.automationMaster.value.automation_schedule_type.toString() == AutomationScheduleType[AutomationScheduleType.Day]) {
          this.SelectedAutomationScheduleTypeFormControl.setValue(this.automationScheduleTypes[0]);
          this.SelectedAutomationTimingFormControl.setValidators(this.isBackendAutomation() ? null : Validators.required);
          this.setAutomationData();
        }
        else {
          this.SelectedAutomationScheduleTypeFormControl.setValidators(this.isBackendAutomation() ? null : Validators.required);
        }

        if (this.SelectedAutomationTimingTypeFormControl.value === 'Immediate' || this.SelectedAutomationTimingTypeFormControl.value === 'SameDay') {
          this.SelectedAutomationTimingFormControl.setValidators(this.isBackendAutomation() ? null : Validators.required);
          this.SelectedAutomationScheduleTypeFormControl.disable();
          this.SelectedAutomationTimingFormControl.disable();
        } else {
          this.SelectedAutomationScheduleTypeFormControl.enable();
          this.SelectedAutomationTimingFormControl.enable();
        }
      }
      else {
        this.setAutomationData();
      }
    }

    this.SelectedAutomationTimingTypeFormControl.valueChanges.pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        this.setAutomationData();

        if (value === 'Immediate' || value === 'SameDay') {
          this.SelectedAutomationTimingFormControl.setValidators(Validators.required);
          this.SelectedAutomationScheduleTypeFormControl.disable();
          this.SelectedAutomationTimingFormControl.disable();
        } else {
          this.SelectedAutomationScheduleTypeFormControl.enable();
          this.SelectedAutomationTimingFormControl.enable();
        }
      });
      this.SelectedAutomationScheduleTypeFormControl.valueChanges.pipe(distinctUntilChanged())
        .subscribe((value: any) => {
          this.setAutomationData();
        });
  }


  setAutomationData() {
    let timing:string="";
    this.translateService.get('AUTOMATION.EVENT.'+this.automationMaster.value.automation_type)
    .subscribe((translation) => {
      timing = `(${this.SelectedAutomationTimingTypeFormControl.value} ${translation})`;
    });
   // let timing = `(${this.SelectedAutomationTimingTypeFormControl.value} ${this.automationMaster.value.automation_type})`;
    var scheduletype = AutomationScheduleType[this.automationMaster.value.automation_schedule_type.toString() as keyof typeof AutomationScheduleType];
    var eventType = AutomationTimings[this.SelectedAutomationTimingTypeFormControl.value.toString() as keyof typeof AutomationTimings];
    this.automationTimingOptions = this.commonService.createKeyValueArray(scheduletype, timing, eventType);
    if(this.isBackendAutomation()){
      this.SelectedAutomationScheduleTypeFormControl.clearValidators();
      this.SelectedAutomationTimingTypeFormControl.clearValidators();
      this.SelectedAutomationTimingFormControl.clearValidators();
      this.showDefaultMessage = true;
    }
    else{
      var timingOption = this.automationMaster.value.automation_timings.find(timing => timing != AutomationTimings[AutomationTimings.NonAutomation]);
      this.SelectedAutomationTimingTypeFormControl.setValidators(Validators.required);
      this.showDefaultMessage = false;
    }
    
  }

  selectSendMessageOption(option: string): void {
      if(option == 'OnEvent'){
        option= this.automationMaster.value.automation_timings.find(timing => timing == "Immediate" || timing == "SameDay")!;
      }
      this.selectedSendMessageOption = option;
      this.SelectedAutomationTimingTypeFormControl.setValue(option, {emitEvent: true});
      if (option === 'Immediate' || option === 'SameDay') {
        this.SelectedAutomationTimingFormControl.setValidators(Validators.required);
        this.SelectedAutomationScheduleTypeFormControl.disable();
        this.SelectedAutomationTimingFormControl.disable();
      } else {
        this.SelectedAutomationScheduleTypeFormControl.enable();
        this.SelectedAutomationTimingFormControl.enable();
      }
    this.cd.detectChanges();
  }

  get SelectedAutomationTimingTypeFormControl() {
    return this.formGroup.controls['automation_timings_type'] as UntypedFormControl;
  }

  get SelectedAutomationTimingFormControl() {
    return this.formGroup.controls['automation_timing'] as UntypedFormControl;
  }

  get SelectedAutomationScheduleTypeFormControl() {
    return this.formGroup.controls['automation_schedule_type'] as UntypedFormControl;
  }

  isBackendAutomation():boolean{
    return this.automationMaster.value.automation_timings.length == 1 &&
     (this.automationMaster.value.automation_timings.includes(AutomationTimings[AutomationTimings.NonAutomation]) 
     || this.automationMaster.value.automation_timings.includes(AutomationTimings[AutomationTimings.BackendImmedidate])
    || this.automationMaster.value.automation_timings.includes(AutomationTimings[AutomationTimings.BackendNonImmedidate]));
  }

  checkHaveSameDayOrImmediate(option:string):boolean{
    if(option == 'OnEvent'){
      return this.automationMaster.value.automation_timings.includes('Immediate') || this.automationMaster.value.automation_timings.includes('SameDay');
    }
    else{
      return this.automationMaster.value.automation_timings.includes(option);
    }
  }

}
